class ViewportPrefetch extends HTMLElement {
  connectedCallback() {
    if (!('IntersectionObserver' in window)) return;

    const conn = navigator.connection;
    if (conn && conn.saveData) return;
    if (conn && conn.effectiveType && conn.effectiveType.includes('2g')) return;

    this._observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          const link = entry.target;
          this._observer.unobserve(link);
          this._schedule(() => this._prefetch(link.href));
        }
      },
      { rootMargin: '200px', threshold: 0 }
    );

    this.querySelectorAll('a[href]').forEach((link) => {
      if (link.origin !== location.origin) return;
      if (link.pathname + link.search === location.pathname + location.search) return;
      this._observer.observe(link);
    });
  }

  disconnectedCallback() {
    if (this._observer) this._observer.disconnect();
  }

  _schedule(fn) {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(fn);
    } else {
      setTimeout(fn, 1);
    }
  }

  _prefetch(url) {
    const done = window.__viewportPrefetched || (window.__viewportPrefetched = new Set());
    if (done.has(url)) return;
    done.add(url);

    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = url;
    link.as = 'document';
    document.head.appendChild(link);
  }
}

if (!customElements.get('viewport-prefetch')) {
  customElements.define('viewport-prefetch', ViewportPrefetch);
}
